import { useEffect, useState } from 'react';

const links = [
  { href: '#king', label: '年度瓜王榜' },
  { href: '#gualist', label: '全年瓜单' },
  { href: '#month', label: '月度回望' },
  { href: '#talk', label: '热聊现场' },
  { href: '#faq', label: '食用 FAQ' },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? 'border-b border-background-200/80 bg-background-50/85 backdrop-blur-md' : 'border-b border-transparent bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜王 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-heading text-lg font-black text-background-50">
            瓜
          </span>
          <span className="font-heading text-xl font-black tracking-tight">吃瓜王</span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#talk"
            className="flex items-center gap-1.5 rounded-full border border-background-300/80 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-background-400 hover:text-foreground-950"
          >
            <i className="ri-message-3-line text-base"></i>
            <span className="whitespace-nowrap">进楼开聊</span>
          </a>
          <a
            href="#king"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            看年度瓜王
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="flex flex-col gap-1 border-t border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur-md md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#king"
            onClick={() => setOpen(false)}
            className="mt-1 flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
          >
            看年度瓜王
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>
      )}
    </header>
  );
}